import { createHttpEndpoint } from '../../utils'

/**
 * OLD SCHOOL EXPORT
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/catalog-access-api/definition#tag/Listings/paths/~1bm~1catalog~1listings~1export/post}
 */
export const postListingsExport = createHttpEndpoint({
  method: 'POST',
  operationId: 'csvExportRequest',
  path: '/bm/catalog/listings/export',
})

/**
 * Update a batch of listings asynchronously
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/catalog-access-api/definition#tag/Listings/paths/~1bm~1catalog~1listings~1batch-update/post}
 */
export const postListingsBatchUpdate = createHttpEndpoint({
  method: 'POST',
  operationId: 'csvUpdateRequest',
  path: '/bm/catalog/listings/batch-update',
})

/**
 * Partially updates a specific listing
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/catalog-access-api/definition#tag/Listings/paths/~1bm~1catalog~1listings~1{id}/patch}
 */
export const patchListing = createHttpEndpoint({
  method: 'PATCH',
  operationId: 'updateListing',
  path: '/bm/catalog/listings/:listingId',
  transformResponseToCamelCase: true,
})

/**
 * TODO Add link to API specs when available
 */
export const postListingsBatchUpsertWithProducts = createHttpEndpoint({
  method: 'POST',
  operationId: 'csvImportRequest',
  path: '/bm/catalog/listings/batch-upsert-with-products',
})
